
import { styled } from '@mui/material/styles';
import MuiTableCell from '@mui/material/TableCell';
import EDBox from '../../EDBox/EDBox';

export const EDStickyTableHeaderCell: React.FC<
  React.PropsWithChildren
> = props => (
  <StyledTableCell>
    <StyledBox>{props.children}</StyledBox>
  </StyledTableCell>
);

const StyledTableCell = styled(MuiTableCell, { name: 'StickyTableHeaderCell' })(
  ({ theme }) => ({
    width: 'var(--col-width)',
    boxSizing: 'border-box',
    padding: 0,
    border: 0,
    position: 'relative',
    backgroundColor: `var(--first-row-background, ${theme.palette.background.paper})`,
  })
);

const StyledBox = styled(EDBox, { name: 'StickyTableHeaderCellContent' })(
  ({ theme }) => ({
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    padding: 'var(--first-row-padding, 0)',
    overflow:
      'var(--first-row-overflow, hidden)' as React.CSSProperties['overflow'],
    borderRight: `1px solid ${theme.customProperties.DataGrid.gridBorderColor}`,
    borderBottom: `1px solid ${theme.customProperties.DataGrid.gridBorderColor}`,
    display: 'flex',
    flexDirection:
      'var(--first-row-direction, column)' as React.CSSProperties['flexDirection'],
    justifyContent: 'var(--first-row-alignment, center)',
    alignItems: 'var(--first-row-verticalAlignment, center)',
    textAlign:
      'var(--first-row-textAlignment, center)' as React.CSSProperties['textAlign'],
  })
);
